import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogle, checkAuth } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));
        const searchParams = new URLSearchParams(location.search);

        const credential = hashParams.get('credential') || searchParams.get('credential') || hashParams.get('id_token') || searchParams.get('id_token');
        const token = hashParams.get('token') || searchParams.get('token') || hashParams.get('session_id') || searchParams.get('session_id');

        if (credential) {
          await loginWithGoogle(credential);
          toast.success('🎉 Login com Google realizado com sucesso!');
          navigate('/dashboard', { replace: true });
          return;
        }

        if (token) {
          localStorage.setItem('finance_session_token', token);
          await checkAuth();
          navigate('/dashboard', { replace: true });
          return;
        }

        // Default redirect
        await checkAuth();
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [location, loginWithGoogle, checkAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="text-center max-w-md">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-900 mx-auto"></div>
        <p className="mt-4 text-blue-900 font-medium">Autenticando e redirecionando...</p>
      </div>
    </div>
  );
};


